export * from './cookies-policy-page.component';
